<body class="bg-default">
    <app-loader></app-loader>
    <router-outlet></router-outlet>
</body>